export const LANGUAGE_TO_LOCALE = {
  en: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
};

export default LANGUAGE_TO_LOCALE;
